import { useMemo } from "react";

import type { TimeNav } from "@/components/app-sidebar/navItems";

import { useTimeStatus, useTimeToday } from "./queries";

/**
 * The sidebar's Time item: shown when the firm has time tracking on, with
 * today's unreleased count, in amber when an earlier day is still waiting.
 */
export const useTimeNav = (signedInLawyer: boolean): TimeNav => {
  const status = useTimeStatus(signedInLawyer);
  const today = useTimeToday(signedInLawyer && status.enabled);
  const { data } = today;
  return useMemo(() => {
    const earlier = data?.earlier_unreleased ?? [];
    const carried = earlier.reduce((n, d) => n + d.count, 0);
    return {
      enabled: status.enabled,
      isAdmin: status.is_admin,
      unreleased: (data?.unreleased_today ?? 0) + carried,
      carriedOver: earlier.length > 0
    };
  }, [status.enabled, status.is_admin, data]);
};
